module.exports = __webpack_public_path__ + "img/home-two-1.c2b628cd.png";